import '@/assets/js/bytetrade';
import axios from '@/service/interceptor';
import { getPrivateKey } from '@/service';
import { ConstantUtil } from '@/utils/ConstantUtil';
import settings from '@/utils/settings';
import Ruc from '@/utils/Ruc';
import BigNumber from 'bignumber.js';
import Config from '@/utils/Config';
import Utils from '@/utils/Utils';
import store from '@/store';

function getBalance(userId, type = 'balance', userToken = '', email = '') {
    const pm = new Promise((resolve, reject) => {
        let data = {
            cmd: settings.cmd.listAccounts,
            userid: userId,
            userToken,
            email,
        };
        if (type === 'trade') {
            data = Object.assign(data, {
                channel: 'all',
                reqType: 'second',
            });
        }
        axios
            .get(`${settings.SERVER_PREFIX}/me`, {
                params: data,
            })
            .then((res) => {
                if (res.data.code === 0) {
                    resolve(res.data);
                } else {
                    reject({
                        code: res.data.code,
                    });
                }
            });
    });
    return pm;
}

function getMoneyInfo(market) {
    const pm = new Promise((resolve, reject) => {
        const data = {
            cmd: settings.cmd.markets,
            market,
        };
        axios
            .get(`${settings.SERVER_PREFIX}/me`, {
                params: data,
            })
            .then((res) => {
                if (res.data.code === 0) {
                    resolve(res.data);
                } else {
                    reject(res.data);
                }
            });
    });
    return pm;
}

function generateTr(Trbuilder, proposaler, method, ob, privatekey) {
    const tr = new Trbuilder();

    tr.add_type_operation(method, ob);
    tr.dapp = Utils.getDapp(proposaler);
    tr.propose({
        fee: ConstantUtil.Number.PackageFee * (10 ** settings.getBasePrecision('1')),
        proposaler,
        expiration_time: Math.ceil(Date.now() / 1000),
        proposed_ops: [],
    });

    tr.timestamp = Math.ceil(Date.now() / 1000);
    tr.validate_type = 0;
    if (privatekey) {
        tr.add_signer(privatekey);
    }
    return tr;
}

function createOrder(Trbuilder, proposaler, method, ob, privatekey) {
    const tr = new Trbuilder();
    tr.dapp = Utils.getDapp(proposaler);
    tr.add_type_operation(method, ob);
    tr.timestamp = Math.ceil(Date.now() / 1000);
    tr.validate_type = 0;
    if (privatekey) {
        tr.add_signer(privatekey);
    }
    return tr;
}

function withDrawAction({ accountInfo, currTarget, password, obb, targetAddress, amount, feeTrObj }) {
    const ob = obb;
    const pm = new Promise((resolve, reject) => {
        let privateKey;
        if (!Config.CenterTrade) {
            privateKey = getPrivateKey(accountInfo, password);
            if (privateKey.toPublicKey().toAddressString() !== accountInfo.address) {
                reject({ code: 403, errmsg: 'account_password_wrong' });
            }
        }

        const op = ConstantUtil.LikeBTCChainIds.includes(currTarget.chain_type) ? 'withdraw2' : 'withdraw';
        let tr;
        if (!Config.CenterTrade) {
            if (ConstantUtil.LikeBTCChainIds.includes(currTarget.chain_type)) {
                ob.asset_fee = currTarget.feerate;
                tr = createOrder(
                    window.bytetrade_js.TransactionBuilder,
                    accountInfo.userid,
                    op,
                    ob,
                    privateKey,
                );
            } else {
                tr = generateTr(
                    window.bytetrade_js.TransactionBuilder,
                    accountInfo.userid,
                    op,
                    ob,
                    privateKey,
                );
            }
            tr.finalize().then(() => {
                if (!Config.CenterTrade && !tr.signed) {
                    tr.sign();
                }
                const trObject = tr.toObject();
                const cmd = ConstantUtil.LikeBTCChainIds.includes(currTarget.chain_type) ? 'withdrawNotify2_btc' : 'withdrawNotify2';
                let newParams = {
                    cmd,
                    toExternalAddress: targetAddress,
                    chain_type: currTarget.chain_type,
                    chainContractAddress: currTarget.chain_contract_address,
                    transaction: JSON.stringify(trObject),
                    feeTransaction: JSON.stringify(feeTrObj),
                };
                if (Config.CenterTrade) {
                    newParams = {
                        cmd,
                        amount,
                        address: targetAddress,
                        asset: currTarget.id,
                    };
                }
                let url = settings.pixiu;
                if (Config.CenterTrade) {
                    url = `${settings.SERVER_PREFIX}/me`;
                }
                axios.post(url, newParams).then((res) => {
                    resolve(res.data);
                });
            });
        } else {
            let newParams = {};
            if (Config.CenterTrade) {
                const cmd = ConstantUtil.LikeBTCChainIds.includes(currTarget.chain_type) ? 'withdrawNotify2_btc' : 'withdrawNotify2';
                newParams = {
                    cmd,
                    amount,
                    address: targetAddress,
                    asset: currTarget.id,
                };
            }
            let url = settings.pixiu;
            if (Config.CenterTrade) {
                url = `${settings.SERVER_PREFIX}/me`;
            }
            axios.post(url, newParams).then((res) => {
                resolve(res.data);
            });
        }
    });
    return pm;
}

function transferAction(
    accountInfo,
    currTarget,
    password,
    targetAddress,
    amt,
    avabtt,
    msg,
) {
    const pm = new Promise((resolve, reject) => {
        const taddress = targetAddress.trim();
        let amount = amt;
        if (taddress === '') {
            reject('TheAddressNotEmpty');
        }
        if (amount === '') {
            reject('TheAmountNotEmpty');
        }

        amount = parseFloat(amount);
        // if (
        //     (parseFloat(avabtt) <
        //         ConstantUtil.Number.PackageFee + parseFloat(amount) &&
        //         currTarget.id === 1) ||
        //     parseFloat(avabtt) < ConstantUtil.Number.PackageFee
        // ) {
        //     reject('BttIsNotEnough');
        // }
        let _amount = parseFloat(amount);
        if (_amount > parseFloat(currTarget.available)) {
            reject('trade_balance_not_enough');
        }
        if (currTarget.asset === 1 && !taddress.startWith('BTT')) {
            reject('TheAddressIsInvalid');
        }
        if (accountInfo.address === taddress) {
            reject('TheSameAddress');
        }
        const message = msg.trim();
        if (message.length > 128) {
            reject('The charector is not greater than 128');
        }
        let privateKey;
        Ruc.checkUserNameStatus(targetAddress).then((res) => {
            if (res.code !== 0) {
                if (password && password !== null && password !== '') {
                    privateKey = getPrivateKey(accountInfo, password);
                }
                if (privateKey && privateKey.toPublicKey().toAddressString() !== accountInfo.address) {
                    reject('account_password_wrong');
                }
                _amount = (BigNumber(_amount)).times(10 ** (JSON.stringify(currTarget.base_precision).match(/0/g).length));
                const tr = createOrder(window.bytetrade_js.TransactionBuilder, accountInfo.userid, 'transfer2', {
                    fee: ConstantUtil.Number.PackageFee * (10 ** settings.getBasePrecision('1')),
                    from: accountInfo.userid,
                    to: targetAddress,
                    asset_type: currTarget.id,
                    amount: _amount.toFixed(0),
                    message,
                }, privateKey);
                tr.finalize().then(() => {
                    if (password && !tr.signed) {
                        tr.sign();
                    }
                    const trObject = tr.toObject();
                    const dataParams = {
                        cmd: settings.cmd.putTransaction,
                        id: tr.id_int(),
                        method: 'blockchain.put_transaction',
                        trObject: JSON.stringify(trObject),
                    };
                    axios.post(`${settings.SERVER_PREFIX}/me`, dataParams).then((resp) => {
                        if (resp.data.code === 0) {
                            resolve(resp.data);
                        } else {
                            reject(resp.data);
                        }
                    }).catch(() => {
                        reject('Error');
                    });
                });
            } else {
                reject('account_username_not_exist');
            }
        });
    });
    return pm;
}

export async function getEmptyTransaction({ accountInfo = store.getters.currAccount, password }) {
    if(!password || !accountInfo) return undefined;
    const privateKey = getPrivateKey(accountInfo, password);
    if (!privateKey) return undefined;
    const tr = createOrder(
        window.bytetrade_js.TransactionBuilder,
        accountInfo.userid,
        'transfer2',
        {
            fee: ConstantUtil.Number.PackageFee * (10 ** settings.getBasePrecision('1')),
            from: accountInfo.userid,
            to: accountInfo.userid,
            asset_type: 1, // btt
            amount: 1, // minimum
            message: 'empty_transaction',
        },
        privateKey,
    );
    await tr.finalize();
    if (!tr.signed) {
        tr.sign();
    }
    return tr.toObject();
}

async function getTransfer2Obj({
    accountInfo = store.getters.currAccount,
    password,
    to = store.getters.currAccount.userid,
    asset = {
        id: 1,
        base_precision: 1000000000000000000,
    },
    amount = "1",
    message = Config.channel,
}) {
    if(!password || !accountInfo) return undefined;
    const privateKey = getPrivateKey(accountInfo, password);
    if (!privateKey) return undefined;
    console.log('trParams', [
        window.bytetrade_js.TransactionBuilder,
        accountInfo.userid,
        'transfer2',
        {
            fee: ConstantUtil.Number.PackageFee * (10 ** settings.getBasePrecision('1')),
            from: accountInfo.userid,
            to,
            asset_type: asset.id,
            amount: BigNumber(amount).times(10 ** (JSON.stringify(asset.base_precision).match(/0/g).length)).toFixed(),
            message,
        },
        privateKey,

    ])
    const tr = createOrder(
        window.bytetrade_js.TransactionBuilder,
        accountInfo.userid,
        'transfer2',
        {
            fee: ConstantUtil.Number.PackageFee * (10 ** settings.getBasePrecision('1')),
            from: accountInfo.userid,
            to,
            asset_type: asset.id,
            amount: BigNumber(amount).times(10 ** (JSON.stringify(asset.base_precision).match(/0/g).length)).toFixed(),
            message,
        },
        privateKey,
    );
    await tr.finalize();
    if (!tr.signed) {
        tr.sign();
    }
    return tr.toObject();
}

export default {
    getBalance,
    getMoneyInfo,
    withDrawAction,
    transferAction,
    getEmptyTransaction,
    getTransfer2Obj,
};



// WEBPACK FOOTER //
// ./src/utils/balance.js